module.exports = __webpack_public_path__ + "img/beckett.30780cc4.jpg";